import type { ComponentProps } from 'react';
import { Link } from 'react-router';
import { ExternalLink as ExternalIcon } from 'lucide-react';
import { cn, focusRing } from './cn';

/** Link styling: teal, semi-bold, underlined on hover. Use for any in-text or table link. */
export const linkClass = cn('rounded-sm font-bold text-accent no-underline underline-offset-2 hover:text-accent-hover hover:underline', focusRing);

/** An in-app link (react-router) that looks like a link. */
export function TextLink({ className, ...props }: ComponentProps<typeof Link>) {
  return <Link className={cn(linkClass, className)} {...props} />;
}

/** A link leaving the console: opens in a new tab, marked with an arrow icon. */
export function ExternalLink({ className, children, ...props }: ComponentProps<'a'>) {
  return (
    <a target="_blank" rel="noopener noreferrer" className={cn(linkClass, 'inline-flex items-center gap-1', className)} {...props}>
      {children}
      <ExternalIcon size={12} aria-hidden />
    </a>
  );
}
